export const COIN_KEYS = {
  BALANCE: 'coins/balance',
  HISTORY: 'coins/history',
} as const
